import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/shared/store/auth';

/**
 * Guard por rol. Se anida DENTRO de `RequireAuth` (ya hay sesión válida): si el
 * rol del usuario no está en `allow`, redirige al dashboard en vez de renderizar
 * la ruta. Complementa el ocultamiento del menú — evita el acceso directo por URL
 * a las secciones restringidas. (En Fase 4 el gating de SISTEMA pasa a permisos
 * para que los perfiles personalizados con los permisos adecuados también entren.)
 */
export function RequireRole({ allow }: { allow: ReadonlyArray<string> }): JSX.Element {
  const user = useAuthStore((s) => s.user);
  if (user === null || !allow.includes(user.rol)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
